/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import clsx from 'clsx';
import { Chip, Box } from '@material-ui/core';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { getRoleById } from 'shared/enums/Roles';

const useStyles = makeStyles(theme => ({
  ...theme.customTheme,
  chip: {
    [theme.breakpoints.up('xl2')]: {
      fontSize: '18px',
    },
  },
  ROLE_DRAFTER: {
    backgroundColor: theme.palette.roleChip.DRAFTER.main,
    color: theme.palette.roleChip.DRAFTER.contrastText,
    marginLeft: '0.2rem',
  },
  ROLE_SIGNER: {
    backgroundColor: theme.palette.roleChip.SIGNER.main,
    color: theme.palette.roleChip.SIGNER.contrastText,
    marginLeft: '0.2rem',
  },
  ROLE_SENDER: {
    backgroundColor: theme.palette.roleChip.SENDER.main,
    color: theme.palette.roleChip.SENDER.contrastText,
    marginLeft: '0.2rem',
  },
  ROLE_PAYER: {
    backgroundColor: theme.palette.roleChip.PAYER.main,
    color: theme.palette.roleChip.PAYER.contrastText,
    marginLeft: '0.2rem',
  },
  ROLE_END_USER_ADMIN: {
    backgroundColor: theme.palette.roleChip.ADMIN.main,
    color: theme.palette.roleChip.ADMIN.contrastText,
    marginLeft: '0.2rem',
  },
}));

export function RoleChipLabel({ role }) {
  const { t } = useTranslation();

  return (
    <Box display="flex" aria-label={t('user.role')}>
      {t(getRoleById(role)?.i18nKey)}
    </Box>
  );
}

/**
 * Role badge for a user.
 * @param role - user role
 * @returns {JSX.Element}
 */
export default function RoleChip({ role }) {
  const classes = useStyles();

  const CustomizedChip = <Chip label={<RoleChipLabel role={role} />} className={clsx(classes.chip, classes[role])} />;

  return CustomizedChip;
}
